import debounce from 'lodash.debounce';
import tickerService from './ticker-data';

const TYPES = {
	underlying: 'data-underlying-key',
	product: 'data-isin',
};

class TickerRepository {
	constructor(type = 'underlying') {
		this.type = type;
		this.attributeSelector = TYPES[type];

		this.subscriptions = new Map();

		this.newSubscriptions = new Set();
		this.unsubscriptions = new Set();

		this.updateSubscriptions = debounce(this.updateSubscriptions, 250);
	}

	add(id) {
		const subscriptionCount = (this.subscriptions.get(id) || 0) + 1;

		this.subscriptions.set(id, subscriptionCount);

		if (subscriptionCount > 1) {
			return;
		}

		this.newSubscriptions.add(id);

		this.updateSubscriptions();
	}

	remove(id) {
		const subscriptionCount = (this.subscriptions.get(id) || 0) - 1;

		this.subscriptions.set(id, subscriptionCount);

		if (subscriptionCount > 0) {
			// still other subscriptions active, dont unsub
			return;
		}

		this.unsubscriptions.add(id);

		this.updateSubscriptions();
	}

	updateSubscriptions() {
		const subscriptions = [...this.newSubscriptions.keys()];
		const unsubscriptions = [...this.unsubscriptions.keys()];

		this.updateTickerService(subscriptions, unsubscriptions);

		this.newSubscriptions = new Set();
		this.unsubscriptions = new Set();
	}

	updateTickerService(subscribeTo, unsubscribeFrom) {
		tickerService.update(this.type, subscribeTo, unsubscribeFrom);
	}
}

export default TickerRepository;
